<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.currency_feature.currency') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.currency_feature.search')"
              style="width: 300px;"
            />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td>{{ record.currency_name_kh }}</td>
              <td>{{ record.currency_name_en }}</td>
              <td>{{ record.currency_code }}</td>
              <td>{{ record.currency_sign }}</td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="$t('addministration.currency_feature.edit')"
                  class="text-primary mr-3"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('addministration.currency_feature.delete')"
                  class="text-danger"
                  @click.prevent="destroy(record.currency_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'currency',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: this.$t('addministration.currency_feature.name_kh') },
        { name: this.$t('addministration.currency_feature.name_en') },
        {
          name: this.$t('addministration.currency_feature.code'),
          style: 'width: 10%;'
        },
        {
          name: this.$t('addministration.currency_feature.sign'),
          style: 'width: 10%;'
        },
        {
          name: this.$t('addministration.currency_feature.action'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('currency', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.currency.search
      },
      set(newVal) {
        this.$store.commit('currency/SET_SEARCH', newVal)
        this.$store.commit('currency/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('currency/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/currencies/${data.currency_id}`)
    },

    async destroy(id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.currency_feature.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('currency/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'currency-create') {
      this.$store.commit('currency/RESET_STATE')
      this.fetchData()
    }
    next()
  }
}
</script>
